const LOCAL_ACTIVE_AUTH_STATE_KEY = 'genesysActiveAuthConversation';

export const HasActiveAuthConversationState = {
  True: 'true',
  False: 'false',
};

/**
 * @returns {{'true'|'false'}} hasActiveAuthConversation
 */
const get = () => sessionStorage.getItem(LOCAL_ACTIVE_AUTH_STATE_KEY);

/**
 * Set state
 * @param {{'true'|'false'}} hasActiveAuth
 */
const save = (hasActiveAuth) =>
  sessionStorage.setItem(LOCAL_ACTIVE_AUTH_STATE_KEY, hasActiveAuth);

const remove = () => sessionStorage.removeItem(LOCAL_ACTIVE_AUTH_STATE_KEY);

/**
 * An interfact to store and get the active auth conversation state from
 * sessionStorage
 */
export const sessionActiveAuthConversationState = {
  get,
  save,
  remove,
};
